import React, { useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import LoginHeader from './components/LoginHeader';
import LoginForm from './components/LoginForm';
import TrustSignals from './components/TrustSignals';

const Login = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const user = localStorage.getItem('nurtureflow_user');
    if (user) {
      navigate('/analytics-dashboard');
    }
  }, [navigate]);

  return (
    <div className="min-h-screen bg-background relative overflow-hidden">
      {/* Background grid + glow */}
      <div className="absolute inset-0 pointer-events-none" aria-hidden>
        <div
          className="absolute inset-0 opacity-[0.03]"
          style={{
            backgroundImage:
              'linear-gradient(rgba(74,222,128,0.5) 1px, transparent 1px), linear-gradient(90deg, rgba(74,222,128,0.5) 1px, transparent 1px)',
            backgroundSize: '48px 48px',
          }}
        />
        <div
          className="absolute -top-40 -left-40 w-[600px] h-[600px] rounded-full opacity-[0.07]"
          style={{ background: 'radial-gradient(circle, #4ade80 0%, transparent 70%)' }}
        />
        <div
          className="absolute -bottom-40 -right-40 w-[500px] h-[500px] rounded-full opacity-[0.05]"
          style={{ background: 'radial-gradient(circle, #fbbf24 0%, transparent 70%)' }}
        />
      </div>

      <div className="relative flex min-h-screen">
        {/* Left — Login Form */}
        <div className="flex-1 flex flex-col items-center justify-center px-4 py-8 sm:px-6 sm:py-12 lg:px-12">
          <div
            className="w-full max-w-md rounded-2xl p-6 sm:p-8 space-y-0 glass elevation-3"
          >
            <LoginHeader />
            <LoginForm />
          </div>

          {/* Footer links under card */}
          <div className="mt-8 flex items-center gap-6 text-xs text-muted-foreground">
            <span>© {new Date().getFullYear()} Nurture Buddy.ai</span>
            <Link to="/privacy-policy" className="hover:text-foreground transition-smooth">Privacy</Link>
            <Link to="/terms" className="hover:text-foreground transition-smooth">Terms</Link>
            <a href="mailto:support@nurturebuddy.ai" className="hover:text-foreground transition-smooth">Support</a>
          </div>
        </div>

        {/* Right — Feature highlights (desktop only) */}
        <div
          className="hidden lg:flex lg:w-[480px] xl:w-[520px] flex-col justify-center px-12 py-12 border-l border-border"
        >
          <TrustSignals />
        </div>
      </div>
    </div>
  );
};

export default Login;
